import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import dashboardEcommerceReducer from './dashboardEcommerce/reducer'; 

//Calendar


//Invoice


const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    DashboardEcommerce: dashboardEcommerceReducer,
});

export default rootReducer;